/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeHeaderName } from "../../store/layout/actions";

//i18n
import { withTranslation } from "react-i18next";

// Toast
import "toastr/build/toastr.min.css";

//Parts of 'ManagerArea'
import ManagerPanelActivitySummary from "./components/ManagerPanelBody/sub/ActivitySummary/index";
import ManagerPanelFirstContainer from "./components/ManagerPanelBody/sub/ManagerPanelFirstContainer/index";
import ManagerPanelSecondContainer from "./components/ManagerPanelBody/sub/ManagerPanelSecondContainer/index";
import ManagerPanelThirdContainer from "./components/ManagerPanelBody/sub/ManagerPanelThirdContainer/index";
import ManagerFiltersHeader from "./components/ManagerFiltersHeader/index";
import { Row } from "reactstrap";

const ManagerPanel = ({ t }) => {
  const dispatch = useDispatch();

  //States created to be the expand and collapse behavior
  const [onlyFirstContainer, setOnlyFirstContainer] = useState(false);
  const [onlySecondContainer, setOnlySecondContainer] = useState(false);
  const [onlyThirdContainer, setOnlyThirdContainer] = useState(false);

  const [lastUpdateCSAT, setLastUpdateCSAT] = useState(null);

  useEffect(() => {
    if (onlyThirdContainer) {
      dispatch(changeHeaderName(t("CHATS")));
    } else if (onlySecondContainer) {
      dispatch(changeHeaderName(t("AGENTS")));
    } else if (onlyFirstContainer) {
      dispatch(changeHeaderName(t("GENERAL INDICATORS")));
    } else {
      dispatch(changeHeaderName(t("Manager area")));
    }
  }, [onlyThirdContainer, onlySecondContainer, onlyFirstContainer]);

  return (
    <div className="page-content">
      <Row className="w-100 mx-0">
        <ManagerFiltersHeader />
      </Row>
      <div className="row w-100 mx-0">
        <ManagerPanelActivitySummary />
        {!onlyThirdContainer && !onlySecondContainer && (
          <ManagerPanelFirstContainer
            onExpand={(e) => setOnlyFirstContainer(e)}
          />
        )}
        {!onlyFirstContainer && !onlyThirdContainer && (
          <ManagerPanelSecondContainer
            onExpand={(e) => setOnlySecondContainer(e)}
          />
        )}
        {!onlyFirstContainer && !onlySecondContainer && (
          <ManagerPanelThirdContainer
            onExpand={(e) => setOnlyThirdContainer(e)}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ManagerPanel);
